import React from 'react';

import type { ManufacturerEditCardFieldContainerProps } from '../../types/ManufacturerEditCardFieldContainerProps';
import { isManufacturerCardTypeEnabled } from '../../utils/isManufacturerCardTypeEnabled';
import { shouldRenderReadOnlyManufacturerCard } from '../../utils/shouldRenderReadOnlyManufacturerCard';
import { generateManufacturerCardDescription } from '../../utils/generateManufacturerCardDescription';

import ReadOnlyManufacturerCard from './ReadOnlyManufacturerCard';
import { ManufacturerCardEditConditionalContainer } from './ManufacturerCardEditConditionalContainer';

const ManufacturerEditCardFieldContainer: React.FC<
  ManufacturerEditCardFieldContainerProps
> = ({
  manufacturerCardCheckboxProps,
  medicationSelectorDropdownProps,
  cardCategoriesConfigObject,
  isLegacyManufacturerCard = false,
  medication,
}) => {
  if (
    shouldRenderReadOnlyManufacturerCard(
      isLegacyManufacturerCard,
      cardCategoriesConfigObject,
      medication,
    )
  ) {
    return (
      <ReadOnlyManufacturerCard
        id="readOnlyManufacturerCard"
        description={generateManufacturerCardDescription(
          medication,
        )}
      />
    );
  }

  if (
    isManufacturerCardTypeEnabled(cardCategoriesConfigObject)
  ) {
    return (
      <ManufacturerCardEditConditionalContainer
        isLegacyManufacturerCard={isLegacyManufacturerCard}
        manufacturerCardCheckboxProps={
          manufacturerCardCheckboxProps
        }
        medicationSelectorDropdownProps={
          medicationSelectorDropdownProps
        }
      />
    );
  }

  return null;
};

export default ManufacturerEditCardFieldContainer;
